// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterFrontImage_root__1GSae","title":"AfterFrontImage_title__3S-FM"};